<template>
  <div class="manage-requests-header">
    <div class="manage-requests-header-title">
      {{ $t("manageRequests") }}
    </div>

    <base-button v-if="showIgnoreBtn"
                 class="manage-requests-header-ignore-btn"
                 color="light"
                 :loading="loading"
                 @click="$emit('ignoreAll')">
      {{ $t('childRequests.ignoreAll') }}
    </base-button>
  </div>
</template>

<script>
  export default {
    props: {
      showIgnoreBtn: {
        type: Boolean,
        required: false,
        default: true
      },

      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .manage-requests-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      font-size: 20px;
      color: map.get($colors, primary);
    }
  }
</style>